import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function to merge Tailwind CSS classes
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Adaptive sizing utilities
 */
export const adaptiveSize = {
  text: {
    xs: 'text-xs md:text-sm',
    sm: 'text-sm md:text-base',
    base: 'text-base md:text-lg',
    lg: 'text-lg md:text-xl',
    xl: 'text-xl md:text-2xl',
    '2xl': 'text-2xl md:text-3xl',
    '3xl': 'text-3xl md:text-4xl',
    '4xl': 'text-4xl md:text-5xl'
  },
  spacing: {
    1: 'p-1 md:p-2',
    2: 'p-2 md:p-3',
    3: 'p-3 md:p-4',
    4: 'p-4 md:p-6',
    6: 'p-6 md:p-8',
    8: 'p-8 md:p-12'
  }
}

export default { cn, adaptiveSize }